module.exports = {
	"header": "Réclamer la propriété de la fiche",
	"claimRequestSuccess": "Un courriel avec un lien pour réclamer la propriété de cette fiche a été envoyé.",
	"emailButton": "Réclamer votre fiche.",
	"emailAfterButton": "Si vous n'avez pas fait une réclamation de fiche, ignorez tout simplement ce courriel.",
	"emailSubject": "Prendre possession de votre fiche.",
	"invalidToken": "Votre demande de jeton a expiré ou est invalide.",
	"loginHeader": "Vous avez déjà un compte?",
	"paragraph1": "Inscrivez-vous ou connectez-vous pour réclamer la propriété de la fiche et pour être capable de modifier les informations sur votre entreprise.",
	"registerHeader": "Créer un nouveau compte.",
	"success": "Vous êtes maintenant propriétaire du compte d'encanteur et de la fiche."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/claim.json5
// module id = 1974
// module chunks = 6